import React from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import CustomerAccessBanner from "../common/CustomerAccessBanner";
import { useGetCustomerByIdQuery } from "../../features/customer/customerApi";
import { useBaseUrlQuery } from "../../features/login/loginPageApi";
import { jwtDecode } from "../../helpers/utils/AccessControlUtils";

const CustomerAccessNotice = () => {
    const customerId = jwtDecode()?.customerId;
    const { currentData: customer } = useGetCustomerByIdQuery(customerId ?? skipToken, {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true,
    });
    const { data: tenant } = useBaseUrlQuery(window.location.host);

    if (customer?.enabled !== false) return null;

    return <div className="px-4 pt-4"><CustomerAccessBanner supportEmail={tenant?.supportEmail} /></div>;
};

export default CustomerAccessNotice;
